import { AddReactionOutlined, ErrorOutline } from "@mui/icons-material";
import LoopIcon from "@mui/icons-material/Loop";
import { Box, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { withReaction } from "components/hoc";
import { SystemConstant } from "const";
import React, { memo, useEffect, useState } from "react";
import { getInteractor } from "services/local.service";
import { convertString2JSON, formatEmoij, StorageUtil } from "utils";
import ReactionDetailDialog from "./ReactionDetailDialog";
import CipherMessageManager from "pubsub/services/cipher/CipherMessageManager";

const findEncryptTypeProtocol = window.bglobalSignal.libs.EncryptTypeProtocol.find;

const cipherMessageManager = new CipherMessageManager();

const Reaction = withReaction(AddReactionOutlined);

const ReactionFlow = ({ reactionList, message }) => {
  const classes = useStyles();

  const [isShowDialog, setIsShowDialog] = useState(false);
  const [displayReaction, setDisplayReaction] = useState([]);

  const handleShowReactionDialog = () => setIsShowDialog(preState => !preState);

  useEffect(() => {
    const handleReactionArr = reactionList.map(react => {
      if (
        react?.messageEncryptStatus === SystemConstant.MESSAGE_ENCRYPT_STATUS.decryptRecover ||
        react?.messageEncryptStatus === SystemConstant.MESSAGE_ENCRYPT_STATUS.decryptFailed
      ) {
        return SystemConstant.REACTION_DECRYPT_RECOVER;
      }
      return react.content;
    });
    const finalReactionArr = handleReactionArr
      .filter((react, index) => handleReactionArr.indexOf(react) === index)
      .slice(0, 2);

    setDisplayReaction(finalReactionArr);
  }, [reactionList]);

  const handleReloadReaction = async () => {
    const prefixKey = StorageUtil.getCurrentPrefixKey();
    const messageOptions = convertString2JSON(message.options, {});
    const encryptVersion = messageOptions.encrypt_version;
    const encryptTypeProtocol = findEncryptTypeProtocol(encryptVersion);

    const groupDetail = await getInteractor(prefixKey).LocalGroupService.get(message.groupId);
    cipherMessageManager.decryptNormalMessage.decryptRecoverOneMessage(
      message,
      groupDetail,
      encryptTypeProtocol,
      prefixKey,
    );
  };

  return (
    <>
      <Stack direction="row" spacing={0.5}>
        <Box className={classes.reactCounterWrapper} onClick={handleShowReactionDialog}>
          {displayReaction.map(react => {
            if (react === SystemConstant.REACTION_DECRYPT_RECOVER) {
              return (
                <Box
                  className={classes.alignedBox}
                  onClick={event => {
                    event.stopPropagation();
                    handleReloadReaction();
                  }}
                  key={react}
                >
                  <ErrorOutline sx={{ fontSize: 20 }} color="error" />
                  <Box className={clsx(classes.iconLoad, "rotating-icon")}>
                    <LoopIcon sx={{ fontSize: 20 }} />
                  </Box>
                </Box>
              );
            }
            return <Box component="span" key={react} dangerouslySetInnerHTML={{ __html: formatEmoij(react) }} />;
          })}
          {reactionList.length > 1 && (
            <Typography component="span" className={classes.reactCounterNumber}>
              {reactionList.length}
            </Typography>
          )}
        </Box>
        <Reaction message={message} />
      </Stack>

      <ReactionDetailDialog open={isShowDialog} onClose={handleShowReactionDialog} data={reactionList} />
    </>
  );
};

export default memo(ReactionFlow);

const useStyles = makeStyles(theme => ({
  reactCounterWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.grey[100],
    borderRadius: 12,
    cursor: "pointer",
    width: "fit-content",
    padding: "5px 10px",
    gap: 4,
  },

  reactCounterNumber: {
    fontWeight: 400,
    color: theme.palette.black,
  },

  iconLoad: {
    color: "#008FE8",
    fontSize: 24,
    animation: "$rotateReverse 3s linear infinite",
  },
  "@keyframes rotateReverse": {
    from: {
      transform: "rotate(0deg)",
    },
    to: {
      transform: "rotate(-360deg)", // Xoay ngược chiều kim đồng hồ
    },
  },
  alignedBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
}));
